$(document).ready(function() {
  // General
  var activeSamples = window.theme.samples.active
  var activeGWP = window.theme.gwp.active

  // Sample Variables
  var eligibleProductsSamples = window.theme.samples.eligibleProducts
  var sampleProducts = window.theme.samples.freeSamples
  
  // GWP Variables
  var free_gift = window.theme.gwp.freeGiftProduct
  if (window.productMetaData.market == "Europe" || window.productMetaData.market == "United_kingdom" ) {
    var free_gift_inv = window.theme.gwp?.freeGiftInventory?.inventory_europe
  } else if (window.productMetaData.market == "United_states") {
    var free_gift_inv = window.theme.gwp.freeGiftInventory?.inventory_us
  } else {
    var free_gift_inv = window.theme.gwp.freeGiftInventory?.inventory_australia
  }
  var gift_per_product = window.theme.gwp.giftPerProduct

  function checkForFreeGifts () {
    setTimeout(() => {
      jQuery.getJSON('/cart.js', function(cart) {  
        var cartItems = cart.items

        // GWP
        if (activeGWP) {
          var eligibleProductsGWP = window.theme.gwp.eligibleProducts
          var productsInCart = 0;
          var giftsInCart = 0;

          for (let i = 0; i < cartItems.length; i++) {
            if(eligibleProductsGWP.includes(cartItems[i].variant_id)) {
              productsInCart = productsInCart + cartItems[i].quantity;
            } else if(free_gift == cartItems[i].variant_id) {
              giftsInCart = giftsInCart + cartItems[i].quantity;
            }
          }

          if(giftsInCart > 0 && gift_per_product == true && productsInCart > 0 && productsInCart != giftsInCart) { // gifts in cart | gift per product | products in cart
            if (free_gift_inv < productsInCart) {
              var giftValue = free_gift_inv
            } else {
              var giftValue = productsInCart
            }
            CartJS.updateItemById(free_gift, giftValue); 
          } else if (giftsInCart > 0 && productsInCart == 0) { // gifts in cart | No products in Cart
            CartJS.removeItemById(free_gift);
          } else if (giftsInCart == 0 && gift_per_product == true && productsInCart > 0 ) { // no gifts |  products in Cart | gift per product
            if (free_gift_inv < productsInCart) {
              var giftValue = free_gift_inv
            } else {
              var giftValue = productsInCart
            }
            CartJS.addItem(free_gift, giftValue);  
          } else if (giftsInCart == 0 && gift_per_product == false && productsInCart > 0 ) { // no gifts |  products in Cart | no gift per product
            CartJS.addItem(free_gift, 1);  
          }
        }

        // Samples

        if (activeSamples) {
          var samples = [];   
          var freeGiftCount = 0;   
          var eligibleProducts = 0;
          for(var i = 0; i< cartItems.length; i++) { 
            if(eligibleProductsSamples.includes(cartItems[i].variant_id)) {
              eligibleProducts = eligibleProducts + cartItems[i].quantity;
            }
            if(sampleProducts.includes(cartItems[i].variant_id)) {
              freeGiftCount++
            }
          }
          
          if(eligibleProducts > 0) { 
              
            $('.sample-gifts').show();
              
            for(var i = 0; i< cartItems.length; i++) {
              if(sampleProducts.includes(cartItems[i].variant_id)) {
                var sample = cartItems[i].variant_id;
                samples.push(sample);
                var inCart = true;
              }
            }
            
            $('.swiper-container .swiper-slide .product-item').each(function() {
              var id = $(this).attr('data-variant');
              var idParse = parseInt(id);
            
              if($.inArray(idParse, samples) >= 0) {
                  $(this).siblings('.selected-sample').addClass('open--overlay'); 
              }
              else {
                  $(this).siblings('.selected-sample').removeClass('open--overlay');
              }
            });
    
            if(freeGiftCount < 2) {
              $('.sample-overlay').removeClass('open--overlay');
            }
            else {
              $('.sample-overlay').addClass('open--overlay');  
              $('.selected-sample').removeClass('open--overlay');
            } 
          } 
          else if (eligibleProducts == 0 && freeGiftCount > 0 ) {
            for(var i = 0; i< cartItems.length; i++) {
              if(sampleProducts.includes(cartItems[i].variant_id)) {
                CartJS.updateItemById(cartItems[i].variant_id, 0); 
                console.log('5')
              }
            }
            $('.sample-gifts').hide();
          }
          else {
            $('.sample-gifts').hide();
          } 
        }
      })
    })
  }
  
 

  // Plus Click
  $(document).on('click', '.plus_cart', checkForFreeGifts);
  
  // Minus Click
  $(document).on('click', '.minus_cart', checkForFreeGifts); 
  
  if (activeSamples) {
    $(document).on('cart.requestComplete', function(event, cart) {
      var samplesInCart   = 0;
      var eligibleProducts = 0;

      if (cart.item_count == 0) {
        $('.sample-gifts').hide();
      }

      for(var i = 0; i< cart.items.length; i++) { 
        if(eligibleProductsSamples.includes(cart.items[i].variant_id)) {
          eligibleProducts = eligibleProducts + cart.items[i].quantity;
        }
      }
    
      if(eligibleProducts == 0) {  
        for(var i = 0; i< cart.items.length; i++) {
          if(sampleProducts.includes(cart.items[i].variant_id)) {
            samplesInCart += 1;
            CartJS.updateItemById(cart.items[i].variant_id, 0); 
            console.log('6')
          }
        }  
        setTimeout(function() {   
          $('.sample-overlay').removeClass('open--overlay');
        }, 1000); 
      }
      checkForFreeGifts();  
    });
  }


  $(document).on('click', '.remove_cart', () => {
    checkForFreeGifts()
  })
  
  $(document).on('click', '[data-add-to-cart]', () => {
    $('.cart_preview').css('background','#0000002e');
    $('.cart_preview').css('opacity','1');                 
    $('.cart_preview').css('visibility','visible');
    $(".cart_preview_inner").css('transform','translateX(0)');  
    checkForFreeGifts()
  })

  
  // Set up Samples
  if (activeSamples) { 
    $('.swiper-slide .product-item').click(function() {
      $('.sample-overlay').addClass('open--overlay');  
      var id = $(this).attr('data-variant'); 
      CartJS.addItem(id, 1);
      $(this).siblings().addClass('open--overlay'); 
    }); 
  }

  $(document).on('cart.requestStarted', function (event, cart) {
    $('.cart__submit').prop('disabled', true).val('LOADING ..');
  });

  $(document).on('cart.requestComplete', function (event, cart) {
    if (activeSamples) {
      var freeGiftCount = 0;
      for(var i = 0; i< cart.items.length; i++) {
        if(sampleProducts.includes(cart.items[i].variant_id)) {
          freeGiftCount++
        }
      }
      if(freeGiftCount < 2) {
        $('.sample-overlay').removeClass('open--overlay'); 
      } else {
        $('.sample-overlay').addClass('open--overlay'); 
        $('.swiper-container .swiper-slide .product-item').each(function() {
          $(this).siblings('.selected-sample').removeClass('open--overlay');
        }); 
      }
    }

    setTimeout(() => {
      $('.cart__submit').prop('disabled', false).val('CHECKOUT');
    }, 1000)
  });

  checkForFreeGifts();

});
